import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ScreensPage = lazy(() => import('~/features/platform/pages/screens-page'));

export const Route = createFileRoute('/_authenticated/_tenant/platform/screens')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ScreensPage />
    </Suspense>
  ),
});
